import React,{useState} from 'react';
import './DetailsImgComp.css';
import {Grid,Button} from '@mui/material';
import { FaFilter ,FaShare,FaRegHeart, FaHeart} from 'react-icons/fa';
import Img1 from './../Assets/pic1.jpg'
import Img2 from './../Assets/pic2.jpg'
import Img3 from './../Assets/pic3.jpg'
import Img4 from './../Assets/pic4.jpg'
import Img5 from './../Assets/pic5.jpg'
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app
import { Link } from 'react-router-dom';

const DetailsImgComp = () => {

  var [photoIndex,setPhotoIndex] =useState(1)
  var [isOpen,setOpen] =useState(false)
  
  const images = [
    'https://images.unsplash.com/photo-1474917518260-23f84bd71c75?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
    'https://images.unsplash.com/photo-1605281317010-fe5ffe798166?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=844&q=80',
    'https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
    'https://images.unsplash.com/photo-1593351415075-3bac9f45c877?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80',
    'https://images.unsplash.com/photo-1567197399185-baf2309074fb?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80',
    'https://images.unsplash.com/photo-1599582383719-907ff9af1a50?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=876&q=80',
    'https://images.unsplash.com/photo-1616207133639-cd5e4db9859f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=387&q=80'
  ];

  return (
    <>

{isOpen && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setOpen(false)}
            onMovePrevRequest={() =>{
              setPhotoIndex( (photoIndex + images.length - 1) % images.length);
            }
            }
            onMoveNextRequest={() =>{
              setPhotoIndex( (photoIndex + 1) % images.length )
            }
            }
          />
        )}

    <div className='detailsImgCompMain'>
        <p className='detImgCompHeading' style={{fontWeight:700,fontSize:22,textAlign:'left'}}>Lily Beach Resort {'&'} Spa, Maldives, With Pool, AI</p>
        <div className='ImgCompSubDetails'>
        <p style={{fontWeight:700,textDecoration:'underline'}}>Maldives</p>
        <p> <FaShare style={{marginRight:10, cursor:"pointer"}} /> Share <Link to="/register" style={{textDecoration:'none', color:"black"}}><FaRegHeart style={{marginRight:10,marginLeft:40, cursor:"pointer"}} /> Save</Link></p>
        </div>
        <Grid container>
            <Grid item  xs={6} md={6}>
            <img onClick={()=>{
              setOpen(true)
              setPhotoIndex(1)
              setTimeout(()=>{
                setPhotoIndex(0)
              },1000)
            }} className='detImgCompMainImg' src={images[0]} style={{borderTopLeftRadius:20,borderBottomLeftRadius:20}} width={'100%'} height={'350px'} />
            </Grid>

            <Grid item xs={3} md={3} pl={'10px'} className='detImgCompImgParent'>
            <img onClick={()=>{
              setOpen(true)
              setPhotoIndex(0)
              setTimeout(()=>{
                setPhotoIndex(1)
              },1000)
            }}  className='detImgCompImg' src={images[1]} width={'100%'} height={'175px'} style={{marginBottom:0,paddingBottom:'10px'}} />
            <img onClick={()=>{
              setOpen(true)
              setPhotoIndex(1)
              setTimeout(()=>{
                setPhotoIndex(2)
              },1000)
            }}  className='detImgCompImg' src={images[2]} width={'100%'} height={'175px'} style={{marginTop:-7,marginTop:'0px'}} />

            </Grid>

            <Grid item xs={3} md={3} pl={'10px'} className='detImgCompImgParent'>
            <img onClick={()=>{
              setOpen(true)
              setPhotoIndex(2)
              setTimeout(()=>{
                setPhotoIndex(3)
              },1000)
            }}  className='detImgCompImg' src={images[3]} width={'100%'} height={'175px'} style={{marginBottom:0,borderTopRightRadius:20,paddingBottom:'10px'}} />
            <img onClick={()=>{
              setOpen(true)
              setPhotoIndex(3)
              setTimeout(()=>{
                setPhotoIndex(4)
              },1000)
            }}  className='detImgCompImg' src={images[4]} width={'100%'} height={'175px'} style={{marginTop:-7,borderBottomRightRadius:20,marginTop:'0px'}} />
                
            </Grid>
        </Grid>
    </div>
    </>
  )
}

export default DetailsImgComp